import { computed, map } from 'nanostores';
import { DEFAULT_SETTINGS, type Settings } from '~/types/settings';
import type { ThemeOption } from '~/types/theme';

const store = map(initStore());

export { store as settingsGlobalStore };

export const generalSettingsStore = computed(store, (settings) => settings.general);
export const shortcutsStore = computed(store, (settings) => settings.shortcuts);
export const editorSettingsStore = computed(store, (settings) => settings.editor);
export const featurePreviewsStore = computed(store, (settings) => settings.featurePreviews);
export const hostingSettingsStore = computed(store, (settings) => settings.hosting);
export const commandPaletteStore = computed(store, (settings) => settings.commandPalette);

function initStore(): Settings {
  let theme = DEFAULT_SETTINGS.appearance.theme;

  if (!import.meta.env.SSR) {
    const htmlElement = document.querySelector('html') as HTMLHtmlElement;
    theme = htmlElement.getAttribute('data-theme-option') as ThemeOption;
  }

  return {
    ...DEFAULT_SETTINGS,
    appearance: {
      ...DEFAULT_SETTINGS.appearance,
      theme,
    },
  };
}
